/**
 * Keep this convention synchronized with
 * `bedrock-agent-service/src/utils/derived-video-assets.ts`. The standalone
 * agent service cannot import from the app.
 */
const VIDEO_PROXY_SUFFIX = ".proxy.mp4";

export function proxyFilenameForVideo(filename: string): string | null {
  if (!/\.mp4$/i.test(filename) || /\.proxy\.mp4$/i.test(filename)) {
    return null;
  }
  return filename.replace(/\.mp4$/i, VIDEO_PROXY_SUFFIX);
}

export function resolveProxyPreferredFilename(
  filename: string,
  componentAssets: Record<string, string> | null | undefined,
): string {
  const proxyFilename = proxyFilenameForVideo(filename);
  return proxyFilename &&
    componentAssets &&
    Object.hasOwn(componentAssets, proxyFilename)
    ? proxyFilename
    : filename;
}
